import { render, staticRenderFns } from "./main.vue?vue&type=template&id=261b9e64&scoped=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&id=261b9e64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261b9e64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('261b9e64')) {
      api.createRecord('261b9e64', component.options)
    } else {
      api.reload('261b9e64', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=261b9e64&scoped=true&", function () {
      api.rerender('261b9e64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/iframe/main.vue"
export default component.exports